const SCHOOL_TARGET_IDS = new Set([10, 11]);
const SCHOOL_TEXT_PATTERN = /\bschool\b|olympiad|foundation/i;
const OTHER_STREAM_PATTERN = /\b(jee|neet|cuet|bitsat|wbjee)\b/i;
const SCHOOL_FRIENDLY_PATTERN = /foundation|olympiad|school|board|ntse|\bclass\s*\d/i;
const BUNDLE_PLAN_PATTERN = /\(\s*[lpt](?:\s*\+\s*[lpt])*\s*\)|\bmastery\b/i;

export const isSchoolTarget = ({ targetId, targetName } = {}) => {
  if (SCHOOL_TARGET_IDS.has(Number(targetId))) return true;
  return SCHOOL_TEXT_PATTERN.test(String(targetName || ""));
};

const itemText = (item = {}) =>
  [
    item.package_name,
    item.product_name,
    item.title,
    item.course_name,
    item.target_name,
    item.target,
    item.exam_name,
  ]
    .filter((value) => typeof value === "string" || typeof value === "number")
    .join(" ");

export const isSchoolRelevantItem = (item) => {
  const text = itemText(item);
  if (!text) return true;
  if (BUNDLE_PLAN_PATTERN.test(text)) return false;
  if (OTHER_STREAM_PATTERN.test(text) && !SCHOOL_FRIENDLY_PATTERN.test(text)) return false;
  return true;
};

export const filterSchoolItems = (items = []) =>
  Array.isArray(items) ? items.filter(isSchoolRelevantItem) : [];
